// extracted by mini-css-extract-plugin
export default {"container":"E3-z","heading":"F3-z","links":"G3-z","copy":"H3-z","subCopy":"I3-z","linksLeft":"J3-z","linksCenter":"K3-z","linksRight":"L3-z","link":"M3-z","onlyLink":"N3-z"};